import { ref } from 'vue';
import { User } from '@/entities/user';

export const useUserRecord = () => ref<User>({
  name: '',
  email: '',
  notificationEmail: '',
  phoneNumber: '',
  admin: false,
  role: null,
  invite: true,
  entityItems: [],
  entityFolders: [],
  groups: [],
  permissions: [],
  password: null,
});
